import React from 'react';
import { CustomModal } from '../../../../common/CustomModal';
import '../../../../../styles/components/auction-client-pay.scss';
import { getPaymentHistory } from '../services/mzadcomPaymentService';
import { TableSkeleton } from '../../../../common/skelton/TableSkelton';
import DataTable from 'react-data-table-component';
import { tableStyles } from '../../../../../styles/components/js/tableStyle';
import i18n from '../../../../../i18n';
import NoData from '../../../../common/NoData';
import StatusBadge from '../../../../common/StatusBadge';
import { TRANSACTION_STATUS } from '../../../../../constants/status';

export class PaymentHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactions: [],
      isloading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.show && this.props.show) {
      this.fetchPayments();
    }
  }

  fetchPayments = async () => {
    this.setState({ isloading: true });
    try {
      const response = await getPaymentHistory();

      if (response.success) {
        const { data } = response;
        this.setState({
          transactions: data,
        });
      }
    } catch (error) {
      console.error('Failed to fetch wallet balance', error);
    } finally {
      this.setState({ isloading: false });
    }
  };

  getColumns = () => {
    const isArabic = i18n.language === 'ar';
    return [
      {
        name: i18n.t('sl_no'),
        width: '90px',
        sortable: true,
        wrap: true,
        cell: (row, i) => i + 1,
      },
      {
        name: i18n.t('mzad_id'),
        width: '110px',
        sortable: true,
        wrap: true,
        cell: (row) => (
          <span className="highlight-table-value">MZAD {row.auction_relation.id}</span>
        ),
      },
      {
        name: i18n.t('auction_name'),
        minWidth: '160px',
        cell: (row) => (isArabic ? row.auction_relation.title_ar : row.auction_relation.title),
      },
      {
        name: i18n.t('amount'),
        width: '130px',
        cell: (row) => <span className="highlight-table-value">{row.credit ?? 0}</span>,
        wrap: true,
        right: true,
      },
      // {
      //   name: i18n.t('receipt_no'),
      //   width: '140px',
      //   center: true,
      //   cell: (row) => row.receipt_number,
      // },
      // {
      //   name: i18n.t('receipt'),
      //   width: '120px',
      //   center: true,
      //   cell: (row) =>
      //     row.file_receipt ? (
      //       <a
      //         href={`${imageUrl}uploads/wallet/receipt/${row.file_receipt}`}
      //         target="_blank"
      //         rel="noopener noreferrer"
      //         className="receipt-link"
      //       >
      //         {i18n.t('receipt')}
      //       </a>
      //     ) : (
      //       <span className="no-receipt">-</span>
      //     ),
      // },

      {
        name: i18n.t('status'),
        width: '140px',
        cell: (row) => <StatusBadge status={TRANSACTION_STATUS[row.status]} />,
        wrap: true,
        center: true,
      },
    ];
  };

  handleCancel = () => {
    this.setState({
      transactions: [],
    });
    this.props.onClose();
  };

  render() {
    const { show } = this.props;
    const { transactions } = this.state;
    return (
      <CustomModal
        isOpen={show}
        header={i18n.t('transaction_awaiting_approval')}
        onClose={this.handleCancel}
      >
        <div className="Data-Listing">
          {this.state.isloading ? (
            <TableSkeleton columns={5} rows={2} />
          ) : transactions.length ? (
            <DataTable
              keyField={(row) => `${row.id}`}
              responsive={true}
              columns={this.getColumns()}
              data={transactions}
              customStyles={tableStyles}
              highlightOnHover
            />
          ) : (
            <NoData message={i18n.t('no_transaction_available')} />
          )}
        </div>
      </CustomModal>
    );
  }
}
